module.exports = __webpack_public_path__ + "img/foot_circle.ba465ee4.png";